import clientApiManager from '../clientApiManager'

export function nowService(storefrontApiClient = clientApiManager) {
  return storefrontApiClient.get(`/now`);
}



// WEBPACK FOOTER //
// ./src/service/now/nowService.js